import { render, staticRenderFns } from "./EventOverview.vue?vue&type=template&id=3b1e3f31"
import script from "./EventOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./EventOverview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports